import Vue from 'vue'
import Vuex from 'vuex'
import { dashboard } from '@/store/dashboard'
import { profiles } from '@/store/profile'
import { output } from '@/store/output'
import { settings } from '@/store/settings.js'
import { process } from '@/store/process'
import { input } from '@/store/input'
import { fileupload } from '@/store/fileupload'
import { reports } from '@/store/reports'
import { encodings } from '@/store/encoding'
Vue.use(Vuex)

console.log(BUILDTYPE, "BUILDTYPE")

const releaseType = BUILDTYPE == 'PROD' ? 'prodv2' : 'betav1'

const store = new Vuex.Store({
    state: {
        baseUrl: `https://vtranscode.mobiotics.com/${releaseType}/`,
        importFiles: "",
        loginUrl: `https://vauth.mobiotics.com/${releaseType}/provider/v1`,
        uploadUrl: `https://vauth.mobiotics.com/${releaseType}/vauthimage/v1`,
        reportData: "",
        reportInterval: "",
        reportInitiateBy: "",
        initListpackage: "",
        preprocessList: "",
        auth: '',
        dashUrl: `https://vtranscode.mobiotics.com/${releaseType}/`
    },
    getters: {
        getAuthToken: (state) => {
            return state.auth
        },
        getbaseUrl: (state) => {
            return state.baseUrl
        },
        getImportFiles: (state) => {
            return state.importFiles
        },
        getuploadUrl: (state) => {
            return state.uploadUrl
        },
        getloginUrl: (state) => {
            return state.loginUrl
        },
        getReportData: (state) => {
            return state.reportData
        },
        getReportInterval: (state) => {
            return state.reportInterval
        },
        getReportInitiatedBy: (state) => {
            return state.reportInitiateBy
        },
        getInitListPackage: (state) => {
            return state.initListpackage
        },
        getPreprocessList: (state) => {
            return state.preprocessList
        },
        getDashUrl: (state) => {
            return state.dashUrl
        }
    },
    mutations: {
        setAuthToken: (state, data) => {
            state.auth = data
        },
        setImportFiles: (state, data) => {
            state.importFiles = data
        },
        getuploadUrl: (state) => {
            return state.uploadUrl
        },
        setReportData: (state, data) => {
            state.reportData = data
        },
        setReportInterval: (state, data) => {
            state.reportInterval = data
        },
        setReportInitiateBy: (state, data) => {
            state.reportInitiateBy = data
        },
        setInitListPackage: (state, data) => {
            state.initListpackage = data
        },
        setPreprocessList: (state, data) => {
            state.preprocessList = data
        }
    },
    modules: {
        dashboard,
        profiles,
        process,
        output,
        input,
        settings,
        fileupload,
        reports,
        encodings
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js